import React from 'react';
import { FieldArray } from 'redux-form';

import { PlusSquare } from 'jbc-front/components/icons';
import EmployeeLeaveOfAbsenceItem from '../containers/EmployeeLeaveOfAbsenceItem';
import { useTranslation } from 'react-i18next';

const RenderEmployeeLeaveOfAbsences = ({ fields, meta: { error, submitFailed } }) => {
  const { t } = useTranslation();
  return (
    <div>
      {submitFailed && error && <span>{error}</span>}

      {fields.map((item, index) => (
        <EmployeeLeaveOfAbsenceItem key={item} formKey={item} remove={() => fields.remove(index)} />
      ))}
      <div className="u-ta-r u-mt20 u-mb20">
        <div role="button" tabIndex="0" onClick={() => fields.push({})} className="u-txt-addinfo">
          <PlusSquare size={20} className="u-txt-addinfo-icon" />{t('features.Employees.components.EmployeeLeaveOfAbsences.Add_leave_of_absence_period')}
        </div>
      </div>
    </div>
  );
};

const EmployeeLeaveOfAbsences = () => (
  <div>
    <FieldArray name="employeeLeaveOfAbsences" component={RenderEmployeeLeaveOfAbsences} />
  </div>
);

export default EmployeeLeaveOfAbsences;
